"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("./constant");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.day-selector {\n  font-family: 'OpenSansRegular';\n  display: flex;\n  width: 512px;\n  justify-content: space-between;\n  margin-bottom: 0.5rem; }\n  .day-selector span {\n    background: #c6c6c6;\n    border-radius: 50%;\n    height: 2.5rem;\n    width: 2.5rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer; }\n    .day-selector span:hover {\n      background: #a8a8a8; }\n    .day-selector span.selected, .day-selector span.selected:hover {\n      background: #067fdb;\n      color: #ffffff; }\n";
  var fileName = "compone_DaySelector";
  var element = document.querySelector("style[data-sass-component='compone_DaySelector']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var DaySelector = function DaySelector(_ref) {
  var onChange = _ref.onChange,
      values = _ref.values,
      errorMessage = _ref.errorMessage;

  var handleClick = function handleClick(index) {
    var newSelectedDays = _constant.days.map(function (day) {
      return values.includes(day) ? day : null;
    });

    newSelectedDays[index] = newSelectedDays[index] ? null : _constant.days[index];
    onChange(newSelectedDays.filter(function (day) {
      return !!day;
    }));
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "day-selector"
  }, _constant.days.map(function (day, index) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: values.includes(day) ? "selected" : "",
      key: day,
      onClick: function onClick() {
        return handleClick(index);
      }
    }, day.substring(0, 2));
  })), errorMessage && /*#__PURE__*/_react.default.createElement("div", {
    className: "bds-autocomplete-error-message"
  }, errorMessage));
};

DaySelector.propTypes = {
  onChange: _propTypes.default.func,
  values: _propTypes.default.array,
  errorMessage: _propTypes.default.string
};
var _default = DaySelector;
exports.default = _default;